// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side[data-v-3b658ba8] {\n  position: fixed;\n  bottom: 0.02604rem;\n  top: 0.54688rem;\n  z-index: 8;\n}\n@media (max-width: 1366px) {\n.side[data-v-3b658ba8] {\n    top: 0.33854rem;\n}\n}\n@media (max-width: 1280px) {\n.side[data-v-3b658ba8] {\n    top: 0.35417rem !important;\n}\n}\n.right[data-v-3b658ba8] {\n  right: 0.02604rem;\n}\n.left[data-v-3b658ba8] {\n  left: 0.02604rem;\n}\n", ""]);
// Exports
module.exports = exports;
